import { render, staticRenderFns } from "./TenderCard.vue?vue&type=template&id=ee13da14"
import script from "./TenderCard.vue?vue&type=script&lang=js"
export * from "./TenderCard.vue?vue&type=script&lang=js"
import style0 from "./TenderCard.vue?vue&type=style&index=0&id=ee13da14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports